export default __webpack_public_path__ + "static/media/payment-auth-en-light.cd33df98.png";